export default "__VITE_ASSET__CoCIBoTj__"